import { Container } from "@material-ui/core";
import React from "react";

import { IViewer } from "#webapp/src/__schema__";

import { getCurrentOrg } from "#webapp/src/util/org.util";

import { OrgSettings } from "#webapp/src/components/org-settings";
import { Title } from "@clockwise/web-commons/src/ui/admin-panel/title";

interface AdminPanelSettingsProps {
  viewer: IViewer;
}

export const AdminPanelSettings = ({ viewer }: AdminPanelSettingsProps) => {
  const org = getCurrentOrg(viewer);

  if (!org) {
    return null;
  }

  return (
    <Container maxWidth={false}>
      <Title>Organization Settings</Title>
      <OrgSettings user={viewer.user} org={org} />
    </Container>
  );
};
